import React, { PropsWithChildren, useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { Navigate } from 'react-router'
import Navigation from '@App/navigation'

interface RequireAuthProps {}

const RequireAuth = (props: PropsWithChildren<RequireAuthProps>) => {
    const { authStore } = useContext(StoresContext)
    if (!authStore.isLoggedIn) {
        return <Navigate to={Navigation.login.root()} replace />
    }
    return <>{props.children}</>
}

export default RequireAuth
